import { NUMBER } from 'customer-data-objects/property/PropertyTypes';
export const shouldRightAlignProperty = property => property && property.type === NUMBER && property.numberDisplayHint !== 'unformatted';